import { SiAdobexd } from "react-icons/si";
import { RiReactjsLine } from "react-icons/ri";
import { FaServer } from "react-icons/fa";
import { AiFillAppstore } from "react-icons/ai";

const data = [
  // {
  //     id: 1, icon: <SiAdobexd/>, title: 'UI/UX Design', desc: "My designs are modern and intuitive. I use industry-standard rules to make sure your users have fun using your product."
  // },
  {
    id: 1,
    icon: <RiReactjsLine />,
    title: "Frontend Development",
    desc: "Your product will look good and will be accessible on all devices, including mobile phones, tablets, and desktop.",
  },
  {
    id: 2,
    icon: <FaServer />,
    title: "Backend Development",
    desc: "The security of your business/product is taken seriously right from the start of the project. I will make sure your website/app is secure from attacks.",
  },
  {
    id: 3,
    icon: <AiFillAppstore />,
    title: "Full Stack Development",
    desc: "A MERN Stack Developer specializes in building web applications using a combination of technologies: MongoDB, Express.js, React, and Node.js. This tech stack allows developers to create dynamic and efficient applications that cover both frontend and backend development aspects. MERN Stack Developers are skilled in various programming languages and tools, enabling them to craft end-to-end solutions that cater to user experience, functionality, and performance.",
  },
];

export default data;
